type Props = {
  playersLength: number;
  groupSize?: number | null;
  bookingType?: string | null;
  bookingWizardCapacity?: number | null;
};

export function isBookingFull({
  playersLength,
  groupSize = 1,
  bookingType,
  bookingWizardCapacity,
}: Props): boolean {
  if (bookingType === "LessonBooking") {
    return groupSize === playersLength;
  }
  if (bookingType === "RequestBooking") {
    return bookingWizardCapacity === playersLength;
  }
  return playersLength === groupSize;
}
